import { render, staticRenderFns } from "./zhengshu.vue?vue&type=template&id=2dea971f&scoped=true"
import script from "./zhengshu.vue?vue&type=script&lang=js"
export * from "./zhengshu.vue?vue&type=script&lang=js"
import style0 from "./zhengshu.vue?vue&type=style&index=0&id=2dea971f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea971f",
  null
  
)

export default component.exports